import { render, staticRenderFns } from "./SensorsView.vue?vue&type=template&id=64079b6c&"
import script from "./SensorsView.vue?vue&type=script&lang=js&"
export * from "./SensorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports